<!--  ############### Top Select Month Start ################# -->
<div class="select_month_section">
	<section class="row">
		<div class="select_month col-auto">
			<h2>{{"ContractDetails.Name" | translate}}:</h2>
			<p>{{detailsData?.staffName}}</p>
		</div>
		<div class="col-auto co_name">
			<h2>{{"ContractDetails.ContractNo" | translate}}.:</h2>
			<p>{{detailsData?.jobOrderID}}</p>
		</div>
		<div class="col-auto co_name">
			<h2>{{"ContractDetails.OrderNo" | translate}}.:</h2>
			<!-- <p>{{detailsData?.jobOrderID}}</p> -->
             <p>&nbsp;</p>
		</div>
	</section>
</div>
<!--  ############### Top Select Month End ################# -->
<!--  ############### Middle Containt Area Start ################# -->
<div class="container_wrapper">
	<div class="accordion custom_accordion contract_info" id="accordionContractInfo">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_1">
        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_1" aria-expanded="true" aria-controls="collapse_1">
            {{"ContractDetails.Customerinformation" | translate}}
        </button>
        </h2>
        <div id="collapse_1" class="accordion-collapse collapse show" aria-labelledby="heading_1" data-bs-parent="#accordionContractInfo">
            <div class="accordion-body">
                <ul>
                    <li>
                        <p><strong>{{"ContractDetails.CustomerID" | translate}}: </strong><span>{{detailsData?.customerID}}</span></p>
                    </li>
                    <li>
                        <p><strong>{{"ContractDetails.Customercode" | translate}}: </strong><span>{{detailsData?.customerCode}}</span></p>
                    </li>
                    <li>
                        <p><strong>{{"ContractDetails.Customername" | translate}}: </strong><span>{{detailsData?.customerName}}</span></p>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_2">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_2" aria-expanded="false" aria-controls="collapse_2">
            {{"ContractDetails.ContractPeriod" | translate}}
        </button>
        </h2>
        <div id="collapse_2" class="accordion-collapse collapse show" aria-labelledby="heading_2" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails.StartDate" | translate}}: </strong><span>{{detailsData?.startDate}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.EndDate" | translate}}: </strong><span>{{detailsData?.endDate}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_3">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_3" aria-expanded="false" aria-controls="collapse_3">
            {{"ContractDetails.WorkingHours" | translate}}
        </button>
        </h2>
        <div id="collapse_3" class="accordion-collapse collapse show" aria-labelledby="heading_3" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails.StartTime" | translate}}: </strong><span>{{detailsData?.startTime}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.EndTime" | translate}}: </strong><span>{{detailsData?.endTime}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>
    
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_4">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_4" aria-expanded="false" aria-controls="collapse_4">
            {{"ContractDetails.BreakTime" | translate}}
        </button>
        </h2>
        <div id="collapse_4" class="accordion-collapse collapse show" aria-labelledby="heading_4" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails.StartTime" | translate}}: </strong><span>{{detailsData?.bkStartTime}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.EndTime" | translate}}: </strong><span>{{detailsData?.bkEndTime}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_5">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_5" aria-expanded="false" aria-controls="collapse_5">
            {{"ContractDetails.StaffInformation" | translate}}
        </button>
        </h2>
        <div id="collapse_5" class="accordion-collapse collapse show" aria-labelledby="heading_5" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails.StaffID" | translate}}: </strong><span>{{detailsData?.staffID}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.LoginID" | translate}}: </strong><span>{{detailsData?.staffLoginID}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Name" | translate}}: </strong><span>{{detailsData?.staffName}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Kana" | translate}}: </strong><span>{{detailsData?.staffKana}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_6">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_6" aria-expanded="false" aria-controls="collapse_6">
            {{"ContractDetails.JobOrderInformation" | translate}}
        </button>
        </h2>
        <div id="collapse_6" class="accordion-collapse collapse show" aria-labelledby="heading_6" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails.OrderID" | translate}}: </strong><span>{{detailsData?.jobOrderID}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.JobTitle" | translate}}: </strong><span>{{detailsData?.jobTitle}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>
    
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_7">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_7" aria-expanded="false" aria-controls="collapse_7">
            {{"ContractDetails.DepartmentInformation" | translate}}
        </button>
        </h2>
        <div id="collapse_7" class="accordion-collapse collapse show" aria-labelledby="heading_7" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails.DepartmentID" | translate}}: </strong><span>{{detailsData?.cusOfficeID}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.DepartmentCode" | translate}}: </strong><span>{{detailsData?.cusOfficeCode}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Name" | translate}}: </strong><span>{{detailsData?.cusOfficeName}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.PostalCode" | translate}}: </strong><span>{{detailsData?.cusZipCode}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Address" | translate}}: </strong><span>{{detailsData?.cusAddress}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>
    
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_8">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_8" aria-expanded="false" aria-controls="collapse_8">
            {{"ContractDetails.CustomerRepresentative" | translate}}
        </button>
        </h2>
        <div id="collapse_8" class="accordion-collapse collapse show" aria-labelledby="heading_8" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails..PersoninCharge" | translate}}: </strong><span>{{detailsData?.cusChairman}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Supervisor" | translate}}: </strong><span>{{detailsData?.cusComplaint}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.ComplaintContactPerson" | translate}}: </strong><span>{{detailsData?.cusContact}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>
    
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_9">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_9" aria-expanded="false" aria-controls="collapse_9">
            {{"ContractDetails.Approver" | translate}}1
        </button>
        </h2>
        <div id="collapse_9" class="accordion-collapse collapse show" aria-labelledby="heading_9" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails.LoginID" | translate}}: </strong><span>{{detailsData?.apv1LoginID}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Name" | translate}}: </strong><span>{{detailsData?.apv1Name}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Kana" | translate}}: </strong><span>{{detailsData?.apv1Kana}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_10">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_10" aria-expanded="false" aria-controls="collapse_10">
            {{"ContractDetails.Approver" | translate}}2
        </button>
        </h2>
        <div id="collapse_10" class="accordion-collapse collapse show" aria-labelledby="heading_10" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails.LoginID" | translate}}: </strong><span>{{detailsData?.apv2LoginID}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Name" | translate}}: </strong><span>{{detailsData?.apv2Name}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Kana" | translate}}: </strong><span>{{detailsData?.apv2Kana}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_11">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_11" aria-expanded="false" aria-controls="collapse_11">
            {{"ContractDetails.Approver" | translate}}3
        </button>
        </h2>
        <div id="collapse_11" class="accordion-collapse collapse show" aria-labelledby="heading_11" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails.LoginID" | translate}}: </strong><span>{{detailsData?.apv3LoginID}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Name" | translate}}: </strong><span>{{detailsData?.apv3Name}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.Kana" | translate}}: </strong><span>{{detailsData?.apv3Kana}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading_12">
        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse_12" aria-expanded="false" aria-controls="collapse_12">
            {{"ContractDetails.DispatchRepresentative" | translate}}
        </button>
        </h2>
        <div id="collapse_12" class="accordion-collapse collapse show" aria-labelledby="heading_12" data-bs-parent="#accordionContractInfo">
        <div class="accordion-body">
            <ul>
                <li>
                    <p><strong>{{"ContractDetails.BranchCode" | translate}}: </strong><span>{{detailsData?.brcID}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.BranchName" | translate}}: </strong><span>{{detailsData?.brcName}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.PersoninCharge" | translate}}: </strong><span>{{detailsData?.brcChaiman}}</span></p>
                </li>
                <li>
                    <p><strong>{{"ContractDetails.ComplaintContactPerson" | translate}}: </strong><span>{{detailsData?.brcComplaint}}</span></p>
                </li>
            </ul>
        </div>
        </div>
    </div>

    </div>
	
</div>
<!--  ############### Middle Containt Area End ################# -->
